import ReportNew from '../Common/ReportNew'

function EndorsementNew() {
  return <ReportNew isRenewal={false} />
}

export default EndorsementNew